import { render, staticRenderFns } from "./RFPDetails.vue?vue&type=template&id=203d8be1"
import script from "./RFPDetails.vue?vue&type=script&lang=js"
export * from "./RFPDetails.vue?vue&type=script&lang=js"
import style0 from "./RFPDetails.vue?vue&type=style&index=0&id=203d8be1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports